export const scrollToId = (id) => {
    const target = document.getElementById(id);
    if (!target) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(target, { offset: -76 });
    } else {
        target.scrollIntoView({ behavior: "smooth" });
    }
};
